// T-098 (v1.8.45, Session 40, 02.10.2026, Kundin-Mail 01.10.2026 "Rechnungen für Buchhaltung verfügbar machen"): Rechnungsarchiv
// für Verwaltung und Buchhaltung. Backend: api/invoice-archive (RechnungsarchivController, Business.Invoicing.Rechnungsarchiv).

export type ZeitraumModus = 'alle' | 'zeitraum' | 'monat';

export interface ArchivFilter {
  modus: ZeitraumModus;
  von: string; // yyyy-MM-dd
  bis: string; // yyyy-MM-dd
  monat: number; // 1..12
  jahr: number;
  quelle: string; // '', 'Buchung', 'Gutschein', 'Bar'
  status: string; // '', 'Bezahlt', 'Teilweise bezahlt', 'Offen', 'Storniert'
  suche: string;
}

const zweistellig = (n: number) => (n < 10 ? `0${n}` : `${n}`);

/** Erster und letzter Tag eines Monats als yyyy-MM-dd. */
export function monatsZeitraum(jahr: number, monat: number): { von: string; bis: string } {
  const letzter = new Date(jahr, monat, 0).getDate();
  return { von: `${jahr}-${zweistellig(monat)}-01`, bis: `${jahr}-${zweistellig(monat)}-${zweistellig(letzter)}` };
}

/** Vormonat des Datums als Startfilter (Buchhaltung arbeitet monatsweise). */
export function vormonat(heute: Date): { jahr: number; monat: number } {
  const m = heute.getMonth(); // 0..11, Vormonat 1-basiert = m
  return m === 0 ? { jahr: heute.getFullYear() - 1, monat: 12 } : { jahr: heute.getFullYear(), monat: m };
}

/** Query-String für die Archiv-Endpunkte; bei "alle" ohne Datumsgrenzen. */
export function archivQuery(f: ArchivFilter): string {
  const p = new URLSearchParams();
  if (f.modus === 'zeitraum' && f.von && f.bis) {
    p.set('von', f.von);
    p.set('bis', f.bis);
  } else if (f.modus === 'monat') {
    const z = monatsZeitraum(f.jahr, f.monat);
    p.set('von', z.von);
    p.set('bis', z.bis);
  }
  if (f.quelle) p.set('quelle', f.quelle);
  if (f.status) p.set('status', f.status);
  if (f.suche.trim()) p.set('suche', f.suche.trim());
  const s = p.toString();
  return s ? `?${s}` : '';
}

/** CSS-Klasse der Statusmarke (Farbcode wie in der Legende). */
export function statusKlasse(status: string): string {
  switch (status) {
    case 'Bezahlt': return 'archiv-status-bezahlt';
    case 'Teilweise bezahlt': return 'archiv-status-teilweise';
    case 'Storniert': return 'archiv-status-storniert';
    default: return 'archiv-status-offen';
  }
}

/** Dateiname aus dem Content-Disposition-Header (filename* oder filename), sonst Vorgabe. */
export function dateinameAusHeader(header: string | null, vorgabe: string): string {
  if (!header) return vorgabe;
  const stern = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (stern) return decodeURIComponent(stern[1]);
  const einfach = /filename="?([^";]+)"?/i.exec(header);
  return einfach ? einfach[1] : vorgabe;
}
